import copyCodeIcon from "../../../../../../../../../assets/icons/copy_code_blue.svg";
import downloadIcon from "../../../../../../../../../assets/icons/baixar_blue.svg";
import checkIcon from "../../../../../../../../../assets/icons/check.svg";
import copy from 'clipboard-copy';
import { FiSend } from "react-icons/fi";
import { HiDownload } from "react-icons/hi";
import { MdOutlineContentCopy } from "react-icons/md";
import { useQueryClient } from "@tanstack/react-query";
import { useModal } from "../../../../../../../../../hooks/ModalContext";
import { ModalErro } from "../../../../../../../../Modal/components/erro";
import { useDividas } from "../../../../../../../../../context/DividasContext";
import { useBoleto } from "../../../../../../../../../context/BoletoContext";
import { useAuth } from "../../../../../../../../../context/AuthContext";
import { QueueProps, useFila } from "../../../../../../../../../context/FilaContext";
import { useChatWhatsApp } from "../../../../../../../../../context/ChatWhatsAppContext";
import { RequestAcionamento } from "../../../../../../../../../types/resgitro-acionamento-interface";
import { usePropostas } from "../../../../../../../../../context/PropostasContext";
import { useNeg } from "../../../../../../../../../context/NegContext";
import { useState } from "react";
import { useFilaTransbordo } from "../../../../../../../../../context/FilaTransbordoContext";

interface ResumoAcordoAccordionProps {
  formaPag: string;
  app: string
}

export const AcordoAccordion = ({ formaPag, app }: ResumoAcordoAccordionProps) => {
  // const { limparNegociacoes, contratos } = useContrato();
  const queryClient = useQueryClient()
  const { canalEnvio, sendAcionamento } = usePropostas()
  const { selectedCredor, devedor, devedorCadastro } = useDividas()
  const { contratoNeg } = useNeg()
  const { setModal } = useModal();
  const { boleto, } = useBoleto()
  const { cookies } = useAuth()
  const { devedorFilaSelected, getChatId, getDevedorFilaSelected, fila } = useFila()
  const { devedorFilaSelected: devFilaTransbordo, getDevedorFilaSelected: getDevFilaTransbordo } = useFilaTransbordo()
  const { endChat, enviarMessages, chatIdHibrido, sendDoc } = useChatWhatsApp()
  const [copiou, setCopiou] = useState(false)


  function formatarTelefone(telefone: string) {
    telefone = telefone.replace(/\D/g, '');
    telefone = telefone.replace(/^(\d{2})(\d{4,5})(\d{4})$/, '($1) $2-$3');
    return telefone;
  }


  function baixarBoleto() {
    window.open(boleto?.url, "_blank");
  }

  async function handleEndChat() {
    const id_chat = devedorFilaSelected.id_chat || devFilaTransbordo._id || ''
    const token = cookies?.whatsapp?.token || ''
    await endChat(id_chat, token)

    if (devedorFilaSelected?.id_queue) {
      await getChatId(Number(devedorFilaSelected.id_queue), '')
      await queryClient.refetchQueries({ queryKey: ['atendimento'] })
      if (fila && devedorFilaSelected?.cpf_cnpj) {
        getDevedorFilaSelected(fila.find(item => item.cpf_cnpj === devedorFilaSelected?.cpf_cnpj) || {} as QueueProps)
      }
    }

    if (devFilaTransbordo?._id) {
      await queryClient.refetchQueries({ queryKey: ['transbordo-atendimento'] })
    }
  }

  async function finalizarAcordo(idacionamento: string, observacao: string,) {
    const acionamento: RequestAcionamento = {
      app,
      cpfCnpj: devedorCadastro.cpfcnpj,
      credor: contratoNeg?.codcredor,
      empresa: 'GAZIN',
      idacionamento,
      observacao,
      stage: '0',
      url: selectedCredor.url_ws,
      telefone: '', // adicionar dps o telefone do discador
      tipo: 'POSICAO',
      usuario: String(cookies?.user?.id_operador),
      agendamento: ``,
      telefoneagendamento: '',
      contrato: devedorCadastro.cpfcnpj,
    }
    if (devedorFilaSelected?.id_chat || devFilaTransbordo?._id) {
      await handleEndChat()
    }
    await sendAcionamento(acionamento)
    setModal('Acordo finalizado com sucesso!', 'Finalizar Tabulação', false, false)
    setModal('Tabulação feita com sucesso!', 'Sucesso', true, false)
  }

  async function enviarCartaAcordoLink(carta: string, isTCD?: boolean, msg?: string) {
    const chat = devedorFilaSelected?.id_chat || devFilaTransbordo?._id || chatIdHibrido || ''
    const token = cookies?.whatsapp?.token || ''
    let text = `Segue o link para visualização da sua carta acordo: ${carta}`
    if (isTCD) {
      text = `Segue o link para visualização da seu termo de confissão: ${carta}`
    }

    if (msg) {
      if (msg.includes('Pix')) {
        await enviarMessages({ type: 'text', text: msg, token, chat, onlySave: false })
        await enviarMessages({ type: 'text', text: carta, token, chat, onlySave: false })
        await queryClient.refetchQueries({ queryKey: ['firstMessages'] })
        return
      }

      text = msg + carta
    }

    await enviarMessages({ type: 'text', text, token, chat, onlySave: false })
    await queryClient.refetchQueries({ queryKey: ['firstMessages'] })
  }

  async function envioDocumento(carta: string,) {
    const chat = devedorFilaSelected?.id_chat || devFilaTransbordo?._id || chatIdHibrido || ''
    const token = cookies?.whatsapp?.token || ''
    let text = `Segue sua carta acordo:`
    await enviarMessages({ type: 'text', text, token, chat, onlySave: false })
    await enviarMessages({
      type: 'document', file: {
        name: 'Carta_Acordo',
        url: carta
      }, token, chat, onlySave: false
    })
    await queryClient.refetchQueries({ queryKey: ['firstMessages'] })

  }


  function copyToClipboard(link: string) {
    copy(link)
  }

  function renderButtons() {
    if (formaPag === 'Boleto') {
      return (
        <>
          <button className="btn-acordo" onClick={() => baixarBoleto()}>
            <div className="my-2 flex h-14 w-16 items-center justify-center rounded-md border border-blue-900">
              <img src={downloadIcon} alt="" />
            </div>
            <p className="w-full">Baixar boleto</p>
          </button>
          <button className="btn-acordo" onClick={() => envioDocumento(boleto?.url)}>
            <div className="my-2 flex h-14 w-16 items-center justify-center rounded-md border border-blue-900">
              <FiSend
                // className="text-primary" 
                color="#4888C3"
                size={24}
              />
            </div>
            <p>Enviar Carta Acordo</p>
          </button>
          <button className="btn-acordo" onClick={() => enviarCartaAcordoLink(boleto?.url)}>
            <div className="my-2 flex h-14 w-16 items-center justify-center rounded-md border border-blue-900">
              <img src={copyCodeIcon} alt="" />
            </div>
            <p>Envio Chat link do boleto</p>
          </button>

          <button className="btn-acordo"
            onClick={() => copyToClipboard(boleto.dadoboleto[0].linhaDigitavel)}
          >
            <div className="my-2 flex h-14 w-16 items-center justify-center rounded-md border border-blue-900">
              <img src={copyCodeIcon} alt="" />
            </div>
            <p>Copiar código de barras</p>
          </button>
        </>
      )
    } else if (formaPag === 'PIX') {
      return (
        <>
          <button className="btn-acordo" onClick={() => baixarBoleto()}>
            <div className="my-2 flex h-14 w-16 items-center justify-center rounded-md border border-blue-900">
              <img src={downloadIcon} alt="" />
            </div>
            <p className="w-full">Baixar Carta Acordo</p>
          </button>
          <button className="btn-acordo" onClick={() => envioDocumento(boleto?.url)}>
            <div className="my-2 flex h-14 w-16 items-center justify-center rounded-md border border-blue-900">
              {/* <img src={copyCodeIcon} alt="" /> */}
              <FiSend
                // className="text-primary" 
                color="#4888C3"
                size={24}
              />
            </div>
            <p>Enviar Carta Acordo</p>
          </button>
          <button className="btn-acordo" onClick={() => enviarCartaAcordoLink(boleto?.dadoboleto[0]?.linhaDigitavel, false, 'Segue o Pix Copia e Cola para pagamento: ')}>
            <div className="my-2 flex h-14 w-16 items-center justify-center rounded-md border border-blue-900">
              <img src={copyCodeIcon} alt="" />
            </div>
            <p>Envio Chat Pix Copia e Cola</p>
          </button>
          <button className="btn-acordo"
            onClick={() => copyToClipboard(boleto?.dadoboleto[0]?.linhaDigitavel)}
          >
            <div className="my-2 flex h-14 w-16 items-center justify-center rounded-md border border-blue-900">
              <img src={copyCodeIcon} alt="" />
            </div>
            <p>Copiar Pix</p>
          </button>
        </>
      )
    } else {
      return (
        <>
          {/* 
          <button className="btn-acordo" onClick={() => enviarCartaAcordoLink(boleto?.url, false, 'Segue o link abaixo para acessar o ambiente de pagamento: ')}>
            <div className="my-2 flex h-14 w-16 items-center justify-center rounded-md border border-blue-900">
              <img src={copyCodeIcon} alt="" />
            </div>
            <p>Envio Chat link de Pagamento</p>
          </button>

          <button className="btn-acordo"
            onClick={() => copyToClipboard(boleto?.url)}
          >
            <div className="my-2 flex h-14 w-16 items-center justify-center rounded-md border border-blue-900">
              <img src={copyCodeIcon} alt="" />
            </div>
            <p>Copiar link Pagamento</p>
          </button> */}
        </>
      )
    }
  }
  return (
    <details
      id="acordo"
      className={`mb-3 w-full border border-gray-300 bg-white ${!boleto?.url && 'pointer-events-none'}`}
    >
      <summary className="flex w-full cursor-pointer justify-between bg-white px-4 py-3 text-xl font-medium text-gray-800 after:content-['+']">
        Acordo
      </summary>

      {
        boleto && boleto?.url && (
          <div className="px-4 py-2">
            <div className="my-4 flex w-full flex-col items-center justify-center gap-4">
              <h2 className="text-xl font-medium text-green-600">
                Acordo Concluído com Sucesso!
              </h2>
              <div className="mb-8 flex h-20 w-20 items-center justify-center rounded-full bg-green-600">
                <img src={checkIcon} alt="" className="h-14 w-14" />
              </div>
              {
                formaPag === 'Pgto em loja' ? (
                  <>
                    <div className="w-8/12 bg-green-100 px-8 py-4 text-primary">
                      <p className="font-medium">
                        Encaminhe o cliente até a loja para efetuar o pagamento.
                      </p>

                    </div>
                  </>
                ) : (
                  <div className="w-8/12 bg-green-100 px-8 py-4 text-primary">
                    <p className="font-medium">
                      Carta/Acordo enviada para os endereços abaixo:
                    </p>
                    <div className="flex gap-4 items-center w-full   py-2 text-primary">
                      <strong>{canalEnvio?.canalrecebimento?.toLocaleUpperCase()}: </strong>
                      <p>{canalEnvio.canalrecebimento === 'sms' ? formatarTelefone(canalEnvio?.destinorecebimento || '') : canalEnvio?.destinorecebimento}</p>
                    </div>
                  </div>
                )
              }


              {
                formaPag !== 'Pgto em loja' && (
                  <div className="my-4 flex w-full items-center justify-center gap-10  ">
                    {renderButtons()}
                  </div>
                )
              }


            </div>
            <div className="w-full">
              {formaPag !== 'Pgto em loja' ? (
                <div className="mb-8 mt-14 flex w-full items-center justify-center gap-8">
                  <button
                    className="flex flex-col items-center px-2"
                    onClick={() => finalizarAcordo('20090', 'Sem Confirmação de Entrega de Link')}
                  >
                    <div className="btn-finalizado">
                      <img src={checkIcon} alt="" className="my-1 h-8 w-8" />
                      <p>Finalizado</p>
                    </div>
                    <p className="wrap my-4 h-10 w-[12rem] text-center text-sm text-gray-500">
                      Sem Confirmação de Entrega de Link
                    </p>
                  </button>
                  <button
                    className="flex flex-col items-center  px-2"
                    onClick={() => finalizarAcordo('20091', 'Com Confirmação de Entrega de Link')}
                  >
                    <div className="btn-finalizado">
                      <img src={checkIcon} alt="" className="my-1 h-8 w-8" />
                      <p>Finalizado</p>
                    </div>
                    <p className="wrap my-4 h-10 w-[12rem] text-center text-sm text-gray-500">
                      Com Confirmação de Entrega de Link
                    </p>
                  </button>
                  <button
                    className="flex flex-col items-center px-2"
                    onClick={() => finalizarAcordo('20092', 'Confirmado Entrega de Link + Autoriz. Pgto')}
                  >
                    <div className="btn-finalizado">
                      <img src={checkIcon} alt="" className="my-1 h-8 w-8" />
                      <p>Finalizado</p>
                    </div>
                    <p className="wrap my-4 h-10 w-[12rem] text-center text-sm text-gray-500">
                      Confirmado Entrega de Link + Autoriz. Pgto
                    </p>
                  </button>
                </div>
              ) : (
                <div className="mb-8 mt-14 flex w-full items-center justify-center gap-8">
                  <button
                    className="flex flex-col items-center px-2"
                    onClick={() => finalizarAcordo('20093 ', 'ACORDO CONCLUIDO e CLIENTE ENCAMINHADO P/ A LOJA')}
                  >
                    <div className="btn-finalizado">
                      <img src={checkIcon} alt="" className="my-1 h-8 w-8" />
                      <p>Finalizado</p>
                    </div>
                    <p className="wrap my-4 h-10 w-[12rem] text-center text-sm text-gray-500">
                      Acordo Concluído e Cliente Encaminhado p/ a Loja
                    </p>
                  </button>
                </div>
              )
              }
            </div>
          </div>
        )
      }

      <ModalErro message="ERRO AO GERAR BOLETO!" />
    </details>
  );
};
